import FSTreeIcon from './FSTreeIcon';
export default FSTreeIcon;
